import { zodResolver } from '@hookform/resolvers/zod';
import { Alert, CircularProgress } from '@mui/material';
import clsx from 'clsx';
import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import MaterialTextField from 'src/components/material/textField';
import featureStyles from '../../RegisterModalShared.module.scss';
import { FirstStepInput, firstStepSchema } from '../const';

interface FirstStepProps {
  onSubmit: (data: FirstStepInput) => void;
  loading: boolean;
  error: string;
}

export const FirstStep: FC<FirstStepProps> = ({ onSubmit, loading, error }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FirstStepInput>({
    resolver: zodResolver(firstStepSchema),
    defaultValues: {
      fullName: '',
      phoneNumber: '',
      password: '',
    },
  });

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={featureStyles.form}
      noValidate
    >
      {error && <Alert severity="error">{error}</Alert>}

      <span>
        <Controller
          name="fullName"
          control={control}
          render={({ field }) => (
            <MaterialTextField
              label="Full Name"
              color="primary"
              variant="outlined"
              helperText={errors.fullName?.message}
              error={!!errors.fullName}
              {...field}
            />
          )}
        />
        <Controller
          name="phoneNumber"
          control={control}
          render={({ field }) => (
            <MaterialTextField
              label="Phone Number"
              color="primary"
              variant="outlined"
              isPhoneNumber
              helperText={errors.phoneNumber?.message}
              error={!!errors.phoneNumber}
              {...field}
            />
          )}
        />
        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <MaterialTextField
              label="Password"
              color="success"
              variant="outlined"
              isPassword
              helperText={errors.password?.message}
              error={!!errors.password}
              {...field}
            />
          )}
        />
      </span>

      <button
        type="submit"
        className={clsx(featureStyles.button, featureStyles['button--primary'])}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress sx={{ color: '#fff' }} size={28} thickness={4} />
        ) : (
          'Continue'
        )}
      </button>
    </form>
  );
};
